import { Link } from "react-router-dom";
import { getHot } from "@/lib/catalog";

interface CategoryEntry {
  type: "movie" | "drama";
  label: string;
  en: string;
  count: number;
  icon: string;
  desc: string;
  image: string;
}

export default function CategoryEntries() {
  const all = getHot();
  const movies = all.filter((t) => t.type === "movie");
  const dramas = all.filter((t) => t.type === "drama");

  const entries: CategoryEntry[] = [
    {
      type: "movie",
      label: "日韩电影",
      en: "MOVIES",
      count: movies.length,
      icon: "ri-film-line",
      desc: "影院级新作与经典片单，悬疑、爱情、家庭剧情一次看全。",
      image:
        "https://readdy.ai/api/search-image?query=Stylized%20cinema%20interior%20with%20empty%20red%20velvet%20seats%20and%20a%20large%20glowing%20screen%2C%20deep%20navy%20blue%20shadows%20with%20warm%20amber%20projector%20light%20beam%2C%20artistic%20minimal%20composition%2C%20cinematic%20atmosphere&width=900&height=600&seq=jk-cat-movie-01&orientation=landscape",
    },
    {
      type: "drama",
      label: "日韩电视剧",
      en: "DRAMAS",
      count: dramas.length,
      icon: "ri-tv-2-line",
      desc: "每周更新热播剧集，追更提醒不错过任何一集。",
      image:
        "https://readdy.ai/api/search-image?query=Cozy%20living%20room%20at%20night%20with%20a%20television%20casting%20a%20soft%20amber%20glow%2C%20deep%20navy%20blue%20room%20shadows%2C%20stylish%20minimal%20interior%2C%20cinematic%20warm%20and%20cool%20color%20contrast%20artistic%20composition&width=900&height=600&seq=jk-cat-drama-01&orientation=landscape",
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
      {entries.map((entry) => (
        <Link
          key={entry.type}
          to={`/category/${entry.type}`}
          className="group relative h-[190px] md:h-[220px] rounded-lg overflow-hidden bg-foreground-950"
        >
          <img
            src={entry.image}
            alt={`${entry.label}分类`}
            title={`${entry.label} 在线观看日韩影视`}
            className="w-full h-full object-cover opacity-70 transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/90 via-foreground-950/60 to-foreground-950/20" />
          <div className="absolute inset-0 p-5 md:p-6 flex flex-col justify-between">
            <div className="flex items-center justify-between">
              <span className="w-10 h-10 rounded-md bg-background-50/12 backdrop-blur-sm border border-background-50/20 flex items-center justify-center text-background-50">
                <i className={`${entry.icon} text-lg w-5 h-5 flex items-center justify-center`} />
              </span>
              <span className="font-label text-[11px] tracking-[0.24em] text-background-50/50">{entry.en}</span>
            </div>
            <div>
              <h3 className="font-heading text-xl md:text-2xl font-black text-background-50">{entry.label}</h3>
              <p className="mt-1.5 text-xs md:text-[13px] text-background-100/70 leading-relaxed line-clamp-2">{entry.desc}</p>
              <div className="mt-3 flex items-center gap-2">
                <span className="px-2 py-0.5 rounded-md bg-accent-500/90 text-[11px] font-label font-semibold text-background-50">
                  {entry.count} 部作品
                </span>
                <span className="inline-flex items-center gap-1 text-[11px] font-label text-background-50/70 group-hover:text-background-50 transition-colors">
                  进入分类 <i className="ri-arrow-right-line w-3.5 h-3.5 flex items-center justify-center" />
                </span>
              </div>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
}